export default "__VITE_ASSET__CERaxHuO__"